import React, { useState } from 'react';
import ArrowUpIcon from '@moda/icons/arrow-up-12';
import { JEWELRY_CATEGORIES } from '../../constants';
import { usePLPParams } from '../../hooks/usePLPParams';
import { useCategoryTree, CategoryTree } from '../../hooks/useCategoryTree';
import { Rotate } from '../Rotate';
import { PageFilterLink } from './PageFilterLink';
import { PageFilterPanel } from './PageFilterPanel';

import './PageFilterCategory.scss';

type Props = {
  categoryTree: CategoryTree | null;
  mobile?: boolean;
  showCounts?: boolean;
  onClose: () => void;
};

export const PageFilterJewelryCategory: React.FC<Props> = ({
  categoryTree,
  mobile,
  showCounts,
  onClose
}) => {
  const {
    params: { category }
  } = usePLPParams();

  const { selectedCategoryNode, activeCategoryNode, getCategoryNodeHref } = useCategoryTree(
    categoryTree
  );

  const [showSubcategories, setShowSubcategories] = useState(false);

  const jewelryCategoryNodes = categoryTree?.children
    ?.find(child => child?.slug === 'women')
    ?.children?.filter(child => child?.slug && JEWELRY_CATEGORIES.includes(child.slug));

  const topLevelCategoryNode = jewelryCategoryNodes?.find(node => node?.slug === 'jewelry');

  const isTopLevel = category === 'jewelry' && !showSubcategories;

  const title =
    category === 'jewelry' ? (isTopLevel ? 'Jewelry' : 'All Jewelry') : activeCategoryNode?.name;

  const categories = isTopLevel ? jewelryCategoryNodes : activeCategoryNode?.children;

  const content = (
    <>
      {!mobile && <h4 className="PageFilterCategory__title">{title}</h4>}

      {(categories || []).map(
        category =>
          category &&
          category.slug &&
          category.slug !== 'sale' && (
            <PageFilterLink
              selected={!isTopLevel && selectedCategoryNode === category}
              key={category.slug}
              to={getCategoryNodeHref(category) || ''}
              onClick={() => (category.slug === 'jewelry' ? setShowSubcategories(true) : onClose())}
            >
              <span>{category.slug === 'jewelry' ? 'All Jewelry' : category.name}</span>

              {showCounts && <span>{category.totalItems}</span>}
            </PageFilterLink>
          )
      )}
    </>
  );

  if (mobile) {
    return (
      <PageFilterPanel onClose={onClose} title="Category">
        {content}
      </PageFilterPanel>
    );
  }

  return (
    <div className="PageFilterCategory">
      {!isTopLevel && (
        <PageFilterLink
          aria-label="Go Back to Jewelry"
          back
          to={topLevelCategoryNode ? getCategoryNodeHref(topLevelCategoryNode) || '' : ''}
          onClick={() => setShowSubcategories(false)}
        >
          <Rotate degrees={-90}>
            <ArrowUpIcon />
          </Rotate>
          Jewelry
        </PageFilterLink>
      )}

      {content}
    </div>
  );
};
